import { useQuery } from "@tanstack/react-query";
import errorTracker from "~/utils/errorTracker";
import { commuteCalculatorKeys, RoutesResponse } from "./index";

const HERE_V8_ENDPOINT = "https://router.hereapi.com/v8/routes?";

interface Location {
  lat: number;
  lng: number;
}

export function useCalculateRoute({
  transportMode,
  origin,
  destination,
  isOpen,
}: {
  transportMode: string;
  origin: string;
  destination: Location | undefined;
  isOpen: boolean;
}) {
  const options = {
    return: "polyline,summary,typicalDuration",
    transportMode,
    origin,
    destination: `${destination?.lat},${destination?.lng}`,
    apiKey: import.meta.env.VITE_HERE_API_KEY as string,
  };

  const fetchRoutes = (): Promise<RoutesResponse> =>
    fetch(HERE_V8_ENDPOINT + new URLSearchParams(options))
      .then((response) => response.json())
      .then((response) => {
        if (
          response.routes.length > 0 &&
          response.routes[0].sections.length > 0
        ) {
          return response.routes[0].sections[0];
        }

        return [];
      })
      .catch((error) => {
        errorTracker.captureException(error);
      });

  return useQuery(commuteCalculatorKeys.list(options), fetchRoutes, {
    enabled: !!options && !!destination && !!origin && isOpen,
  });
}
